import React from 'react'
import "../style.scss";
const Loader = ({list}) => {
  return (
    <div className='container flex justify-center'>
          <div className={list ? "three-list" :   "three col"}>
                <div className={list ? "loader-list" : "loader"} id="loader-1"></div>
        </div>
    </div>
  )
}

export default Loader